// extracted by mini-css-extract-plugin
export default {"HeaderLayout":"styles_HeaderLayout__W5ZYV","title":"styles_title__J6JZc","subTitleContainer":"styles_subTitleContainer__EsMLo","subTitle":"styles_subTitle__TGhv1"};